import {
  EFilterFieldTypes,
  IAppliedFilter,
  IFilterableField,
} from 'v2/common/ComposeFilters/filters';

export function getDisplayFilterableFields(
  filterableFields: IFilterableField[],
  appliedFields: IAppliedFilter[]
): IFilterableField[] {
  const filteredList = filterableFields.filter((field) => {
    if (field.type !== EFilterFieldTypes.owner) {
      return true;
    }

    const isFieldApplied = appliedFields.some(
      (appliedField) => appliedField.field.name === field.name
    );
    return !isFieldApplied;
  });

  return filteredList;
}
